import React from 'react'
import { BreadCrumb } from './BreadCrumb'
import { PolicySection } from './PolicySection'
import "../../../../theme/css/PrivacyPolicy.css"


export const PrivacyPolicy = () => {
    return (
        <div>
            <BreadCrumb/>
            <PolicySection/>
        </div>
    )
}

